import React, { useEffect, useState } from "react";
import { Button, Modal, Box, Grid, Typography, Skeleton } from "@mui/material";
import ReactSelect from "react-select";
import { fetchTemplates } from "../../../../../components/CommonFunctions/DropdownLists";
import { useForm, Controller } from "react-hook-form";
import { toast } from "react-toastify";
import { WhatsappTemplatesAPI } from "../../../../../api/Endpoints/WhatsappTemplateAPI";

function TemplateDropdown({ open, setOpen, watch, setValue }) {
  const {
    control,
    formState: { errors },
  } = useForm();
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchTemplates = async () => {
    setLoading(true);
    try {
      const response = await WhatsappTemplatesAPI.get();
      setLoading(false);
      return response?.data?.data?.data;
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchTemplates().then((templates) => {
      setTemplates(templates);
    });
  }, []);

  const handleClose = () => {
    setOpen(false);
    setValue("template", null);
  };

  const selectTemplate = (template) => {
    setValue("template", template);
  };

  return (
    <div className="quick-send-block" open={open}>
      <div
        className="quick-send-top-block"
        onClick={handleClose}
        style={{ cursor: "pointer" }}
      >
        <span></span>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
        >
          <path
            d="M13 13L1 1M13 1L1 13"
            stroke="black"
            stroke-width="2"
            stroke-linecap="round"
          />
        </svg>
      </div>

      <div className="quick-send-title-block">
        <h3>Quick Send.</h3>
        <Box sx={{width:"50%"}}>
          <Grid sx={{ mt: 1 }}  >
            <ReactSelect
              isLoading={loading}
              isClearable
              options={templates}
              getOptionLabel={(priority) => priority.name}
              getOptionValue={(priority) => priority.id}
              value={watch("template")}
              name="template"
              styles={{ menu: (provided) => ({ ...provided, zIndex: 9999 ,width:"100%"}) }}
              onChange={(e) => {
                setValue("template", e);
              }}
            />
            {/* {errors.template && (
              <Typography color="error" sx={{ mt: 1, fontSize: "12px" }}>
                {errors.template.message}
              </Typography>
            )} */}
          </Grid>

          {/* <Grid sx={{ display: "flex", justifyContent: "end" }}>
            <Button type="submit" color="primary" variant="outlined">
              Send
            </Button>
          </Grid> */}
        </Box>
      </div>

      <div className="quicksend-items-block">
        {loading ? (
          <>
            {[...Array(4)].map((_, index) => (
              <Skeleton
                variant="rectangular"
                width={250}
                height={50}
                sx={{ borderRadius: 2 }}
              />
            ))}
          </>
        ) : (
          templates &&
          templates.slice(0,5).map((item, index) => (
            <div
              className="quicksend-items"
              onClick={() => selectTemplate(item)}
            >
              {item.name}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M8 16L16 8M16 8H10M16 8V14"
                  stroke="#776F69"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
          ))
        )}
      </div>
    </div>
  );
}

export default TemplateDropdown;
